import { Box } from "@mui/material";

/**
 * Componente opcional para layout de formulários que não são filhos diretos de FForm.
 * Ex: Campos dentro de abas de formulário.
 */
export default function FormContent({ sx, children, ...props }) {
    // console.log("props", props)
    return (
        <Box sx={{ display: "flex", alignContent: "flex-start", flex: 1, flexWrap: "wrap", gap: 2, height: "100%", ...sx }}>
            {children}
        </Box>
    );
}
